import {Component, Input, Output, EventEmitter, ViewChild, OnInit, SimpleChanges, OnChanges} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {Observable} from "rxjs";
import {MicroSelectComponent} from "../../shared/select/micro-select.component";

@Component({
  selector: 'micro-chatCarrier-select',
  templateUrl: './chatCarrier-select.component.html'
})
export class ChatCarrierSelectComponent implements OnInit {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  mode:string = 'simple';

  @Output()
  chatCarrierIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  chatCarrierId:any;

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  options:any[];

  change(e) {
    this.chatCarrierIdChange.emit(this.chatCarrierId);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  reload() {
    if (!this.sel.isPlatformServiceAvailable()) {
      return;
    }

    let params:HttpParams = new HttpParams();
    this.sel.loading = true;
    return this.http.get(`${this.env.e.url}/chat/chatCarriers/all`, {params:params})
      .subscribe(data => {
          this.options = data as any[];
          this.sel.loading = false;
        }
      );
  }

  ngOnInit(): void {
    this.reload();
  }
}
